import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Active Compliances',
      value: metrics?.totalCompliances,
      icon: 'FileText',
      color: 'blue',
      bgColor: 'bg-blue-500/10',
      iconColor: 'var(--color-primary)'
    },
    {
      label: 'Completion Rate',
      value: `${metrics?.completionRate}%`,
      trend: metrics?.completionTrend,
      icon: 'CheckCircle',
      color: 'green',
      bgColor: 'bg-green-500/10',
      iconColor: '#10b981'
    },
    {
      label: 'Overdue Items',
      value: metrics?.overdueItems,
      trend: metrics?.overdueTrend,
      icon: 'AlertCircle',
      color: 'red',
      bgColor: 'bg-red-500/10',
      iconColor: '#ef4444'
    },
    {
      label: 'Upcoming Deadlines',
      value: metrics?.upcomingDeadlines,
      trend: metrics?.upcomingTrend,
      icon: 'Clock',
      color: 'orange',
      bgColor: 'bg-orange-500/10',
      iconColor: '#f59e0b'
    },
    {
      label: 'Audit Readiness Score',
      value: `${metrics?.auditReadiness}%`,
      trend: metrics?.auditTrend,
      icon: 'Shield',
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      iconColor: '#8b5cf6'
    }
  ];

  const getTrendColor = (trend) => {
    if (!trend) return 'text-muted-foreground';
    return trend > 0 ? 'text-success' : 'text-destructive';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      {metricCards?.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} color={card?.iconColor} />
            </div>
            {card?.trend && (
              <div className={`flex items-center gap-1 text-xs font-medium ${getTrendColor(card?.trend)}`}>
                <Icon name={card?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} size={14} />
                <span>{Math.abs(card?.trend)}%</span>
              </div>
            )}
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{card?.value}</p>
            <p className="text-sm text-muted-foreground">{card?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;